
/*
Defines the custom element <ravel-menu>
*/

import { RavelMenu } from './src/RavelMenu.js';

customElements.define('ravel-menu', RavelMenu);